<app-auth-shell title="Entrar com link no e-mail" subtitle="Enviamos um link de uso único para o seu e-mail confirmado.">
  @if (isConsumingToken) {
  <div class="auth-confirm">
    <div class="auth-confirm__spinner" role="status" aria-label="Validando link"></div>
    <p class="auth-confirm__text">Validando seu link...</p>
  </div>
  } @else {
  <form role="form" [formGroup]="formMagicLink" (ngSubmit)="requestLink()">
    <div class="auth-field">
      <label class="auth-field__label" for="email">E-mail</label>
      <div class="auth-field__control">
        <input id="email" type="email" formControlName="email" class="auth-field__input" placeholder="nome@empresa.com" autocomplete="email" appFocus />
      </div>
      @if (formMagicLink.get('email')?.dirty) { @if (formMagicLink.get('email')?.hasError('required')) {
      <div class="auth-field__error">Campo obrigatório</div>
      } @if (formMagicLink.get('email')?.hasError('email')) {
      <div class="auth-field__error">E-mail inválido</div>
      } }
    </div>
    <button type="submit" class="auth-btn" [disabled]="!formMagicLink.valid || remainingSeconds > 0">
      @if (remainingSeconds > 0) { Reenviar em {{ remainingSeconds }}s } @else { Enviar link }
    </button>
  </form>
  }
  <div class="auth-shell__links">
    <p class="auth-shell__links-text">
      Prefere senha?
      <a class="auth-link" [routerLink]="['/signin']">Entrar</a>
    </p>
    <p class="auth-shell__legal">
      <a href="https://erpclass.com.br/" target="_blank" rel="noopener noreferrer">SOFTClass</a>
      ·
      <a href="https://erpclass.com.br/" target="_blank" rel="noopener noreferrer">erpclass.com.br</a>
    </p>
  </div>
</app-auth-shell>
